import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import HomePage from '../Components/Home'
import Mcast from '../Components/Mcast'
import Manipal from '../Components/ManipalU'
import Vishalscc from '../Components/Vishalscc'
import Universityob from '../Components/Universityob'
import Omnix from '../Components/Omnix'
import Fdp from '../Components/Fdp'
import Anglia from '../Components/Anglia'
import British from '../Components/British'
import BusinessD from '../Components/Business'
import News from '../Components/news'
import BusinessPage1 from '../Components/innovation'
import Desk1 from '../Components/desk'
import Category from '../Components/Categories/Category'
import DetailsPage from '../Components/Categories/DetailsPage'
import GuestLecture from '../Components/GuestLecture'
import NotFound from '../pages/NotFound'
import SomethingWentWrong from '../pages/SomethingWentWrong'
import HTBD from '../Components/HTBD'
import SingleNews from '../Components/SingleNews'
import ComingSoon from '../pages/ComingSoon'

const Routers = () => {
  return (
    <Router>
      <Routes>
        <Route exact path='/' element={<HomePage />} />
        <Route path='/oops' element={<SomethingWentWrong />} />
        <Route path='/news' element={<News />} />
        <Route path='/news/:slug' element={<SingleNews />} />
        <Route path='/category/:category/:product' element={<DetailsPage />} />
        <Route path='/category/:category' element={<Category />} />
        <Route path='/university/Anglia' element={<Anglia />} />
        <Route path='/business' element={<BusinessD />} />
        <Route path='/university/Mcast' element={<Mcast />} />
        <Route path='/university/Manipal' element={<Manipal />} />
        <Route path='/university/Vishalscc' element={<Vishalscc />} />
        <Route path='/university/Universityob' element={<Universityob />} />
        <Route path='/university/Omnix' element={<Omnix />} />
        <Route path='/university/Fdp' element={<Fdp />} />
        <Route path='/university/British' element={<British />} />
        <Route path='/businessPage' element={<BusinessPage1 />} />
        <Route path='/desk' element={<Desk1 />} />
        <Route path='/htbd' element={<HTBD />} />
        <Route path='/crictics' element={<ComingSoon />} />
        <Route path='/comingsoon' element={<ComingSoon />} />
        <Route path='/guest-lecture' element={<GuestLecture />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Router>
  )
}

export default Routers
